import UIkit from 'uikit';
import Cookies from 'js-cookie';
//Import
import * as select2 from 'select2'
// import scrollify from 'jquery-scrollify'

export default {
  init() {


    // window.addEventListener('load', function () {
    //
    //   if (window.location.hash == '') {
    //     return false;
    //   }
    //
    //   var el = document.querySelector(window.location.hash);
    //
    //   if (el !== null) {
    //     const id = window.location.hash;
    //     const yOffset = -70;
    //     const element = document.getElementById(id);
    //     const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    //
    //     window.scrollTo({top: y, behavior: 'smooth'});
    //
    //     // el.scrollIntoView({ behavior: 'smooth' });
    //
    //   }
    //
    // }, false);

    // TODO - remove
    // function promoNavResize() {
    //   let promoBarHeight = $('#promo-bar:not([style*=none]):not([hidden])').height();
    //   let navHeight = $('#site-header-2').height();
    //   let fullHeight = promoBarHeight + navHeight;
    //   if ($('#promo-bar:not([style*=none]):not([hidden])').length ) {
    //     $('#offcanvas-nav-2 .uk-offcanvas-bar, #offcanvas-nav-2 .overlay-div').css('top', fullHeight + 'px');
    //   } else {
    //     $('#offcanvas-nav-2 .uk-offcanvas-bar, #offcanvas-nav-2 .overlay-div').css('top', navHeight + 'px');
    //   }
    // }
    //
    // $(document).ready(function () {
    //   var resizeTimer;
    //   promoNavResize()
    //   $(window).on('resize', function () {
    //     clearTimeout(resizeTimer);
    //     resizeTimer = setTimeout(function () {
    //       promoNavResize()
    //     }, 250);
    //   });
    //
    // });
    $(document).ready( function() {
      let resizeTimer,
        promoBar = $('#promo-bar'),
        headerNav = $('#site-header-2 .header-nav');

      navPromoHeight()

      $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          navPromoHeight()
        }, 50);
      });

      $('#promo-bar span.close-promo').click(function (e) {
        e.preventDefault();
        navPromoHeight(true)
      })

      $('nav.primary-nav-2 a.uk-navbar-toggle.hamburger').click(function (e) {
        e.preventDefault();
        navPromoHeight()
      })

      function navPromoHeight(promoClick = false) {
        let promoHeight = promoBar.outerHeight(),
          headerHeight = headerNav.outerHeight(),
          totalHeight = promoHeight + headerHeight,
          mobileNav = $('#offcanvas-nav-2 div.uk-offcanvas-bar, #offcanvas-nav-2 .overlay-div'),
          adminBar = $('#wpadminbar').outerHeight();

        if($('body').hasClass('admin-bar')) {
          promoHeight = promoHeight + adminBar
          headerHeight = headerHeight + adminBar
          totalHeight = totalHeight + adminBar;
        }

        $('#site-header-2 div.sticky-placeholder').css('height', headerNav.outerHeight() + 'px');

        if(promoBar.is(':visible')) {
          $('#promo-placeholder').css('height', promoBar.outerHeight() + 'px');
          headerNav.css('top', promoHeight + 'px');
          mobileNav.css('top', totalHeight + 'px');
        } else {
          if($('body').hasClass('admin-bar')) {
            headerNav.css('top', adminBar + 'px');
          } else {
            headerNav.css('top', '0');
          }
          mobileNav.css('top', headerHeight + 'px');
        }

        if(promoClick === true) {
          $('#promo-placeholder').css('height', '0');
          if($('body').hasClass('admin-bar')) {
            headerNav.css('top', adminBar + 'px');
            mobileNav.css('top', headerHeight + 'px');
          } else {
            headerNav.css('top', '0');
            mobileNav.css('top', headerHeight + 'px');
          }
        }


        $('#promo-bar span.close-promo').trigger('promoHeightChanged');
      }
    });

    $(document).ready(function () {
      // load up selec2

      if ($('select.select2').length) {
      //Hook up select2 to jQuery
      //   select2($);
        $('select.select2').select2();
      }
    // set link in MFAP to lightbox
        if ($('[id="4-WRPR"]').length) {
          $('[id="4-WRPR"] div#tfa_7-HTML').attr('uk-lightbox', true).attr('data-attrs', 'width: 1000');
        }
    })

    // IP based geolocation check - if outside of US, open ip-geo-location-modal
    // $(document).ready(function () {
    //
    //   let userIP = '';
    //   $.getJSON('https://api.ipify.org/?format=json', function (e) {
    //     // userIP = e.ip;
    //     let ajaxURL = window.location.origin + '/wp-admin/admin-ajax.php'
    //     $.ajax({
    //       type: 'POST',
    //       dataType: 'json',
    //       url: ajaxURL,
    //       data: {
    //         action: 'get_ip_geoloc',
    //         ipaddress: userIP,
    //       },
    //       success: function (res) {
    //         ipLocation(res)
    //         // console.log(res)
    //       },
    //       error: function (err) {
    //         console.log('error: ' + err);
    //       },
    //     })
    //   })
    //
    //
    //
    // })

    // function ipLocation(data) {
    //   let country = data.body;
    //   let ipModal = $('#ip-location-modal');
    //   let params = new URL(window.location.href).searchParams;
    //   let ref = params.get('ref');
    //
    //   if (window.location.href.indexOf('data-protection-privacy-statement') > -1) {
    //     // console.log('is-data-privacy')
    //   } else {
    //
    //       // if(country.length) {
    //     if (country.toLowerCase().indexOf('united states') <= 0) {
    //       if (Cookies.get('ipLocationModal') === 'cookieSet') {
    //         UIkit.modal(ipModal).hide();
    //       } else {
    //         if (ref === 'EU') {
    //           Cookies.set('ipLocationModal', 'cookieSet', {expires: 7});
    //         } else {
    //           UIkit.modal(ipModal).show();
    //           ipModal.find('a.stay-US').click(function () {
    //             Cookies.set('ipLocationModal', 'cookieSet', {expires: 7});
    //           })
    //         }
    //       }
    //     }
    //
    //   }
    //   // }
    // }

    function injectAELink(data) {
      console.log(data)
    }
    /* Utility - Anchor scroll to accordion item and toggle open
        Example:
        <a href="#{accordion id}" data-accrd="{accordion item index}" uk-scroll="offset: 70">click to scroll</a>
     */
    $('a.scroll-to-accrd').click(function (e) {
      e.preventDefault()
      let accrd = 'ul' + $(this).attr('href')
      let accrd_item = $(this).data('accrd');
      $('html,body').animate({
        scrollTop: $(accrd).offset().top - 70,
      }, 500);
      setTimeout(function () {
        UIkit.accordion(accrd).toggle(accrd_item, true);
      }, 800);
    })


    $(document).ready(function () {
      $('.fa-placeholders .oneField').each(function () {
        var label = $(this).find('label');
        var text = label.text();
        var input = $(this).find('input');
        // if input type does not equal 'checkbox' or 'radio'
        if (input.attr('type') !== 'checkbox' && input.attr('type') !== 'radio') {
          /* if label has class reqMark addpend */
          if (label.hasClass('reqMark')) {
            text = text + '*';
          }
          label.hide();
          input.attr('placeholder', text);
        }
      });
    });

// Fixes icomoon html for filled icons
    if ($('[class*=icon-filled]').length) {
      $('[class*=icon-filled]').each(function () {
        for (var n = 1; n < 10; ++n) {
          $(this).append('<span class="path' + n + '"></span>');
        }
      });
    }

    const urlParams = new URLSearchParams(location.search);
    if (urlParams.has('tfa_next')) {
      if (window.location.href.indexOf('utm_') > -1) {
        let tfaQuery = urlParams.get('tfa_next');
        let path = window.location.href.split('?')[0];
        window.location.href = path + '?tfa_next=' + tfaQuery;
      }
    }

    $('body').addClass('loaded');


    function klv_id_prefill(data) {
      let profile = JSON.parse(data.body);
      let ipModal = $('#footer')
      if (ipModal.length) {
        for (let user in profile.data) {
          let prof = profile.data[user].attributes;
          $('[title="First Name"]').val(prof.first_name);
          $('[title="Last Name"]').val(prof.last_name);
          $('[title*="Email"]').val(prof.email);
          $('[title="Zip Code"]').val(prof.location.zip);
        }
      }
    }

    if (window.location.href.indexOf('klv_id') !== -1) {

      let klv_id = getParameterByName('klv_id');
      let ajaxURL = window.location.origin + '/wp-admin/admin-ajax.php'
      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: ajaxURL,
        data: {
          action: 'klv_id_lookup',
          klv_id: klv_id,
        },
        success: function (res) {
          klv_id_prefill(res)
          // console.log(res)
        },
        error: function (err) {
          // klv_id_prefill(err)
          // console.log(err)
        },
      })
    }


    if (window.location.href.indexOf('tfa_') === -1) {
      if ($('.wForms, .wForm').length > 0) {
        $('input[title="Google Account ID"]').val('UA-142068-1');
        let url = window.location.href;
        $('input[title="Web_Form_URL__c"]').val(url);
        let queryVars = {
          clientid: 'Google_Client_Id__c',
          gclid: 'GCLID',
          utm_medium: 'UTM Medium',
          utm_source: 'UTM Source',
          utm_campaign: 'UTM Campaign',
          utm_content: 'UTM Content',
          utm_term: 'UTM Term',
        }
        $.each(queryVars, function (key, val) {
          let param = getParameterByName(key);
          if (param) {
            $('input[title="' + val + '"]').val(decodeURIComponent(param));
          }
        });
      }
    }


    $('.utm-passalong,.sub-site-id-12+.wrap #main a[href*="myriad.com"],.sub-site-id-12+.wrap #main a[href^="/"] ').each(function () {
      let pass_href = $(this).attr('href');
      if (pass_href.indexOf('?') === -1) {
        $(this).attr('href', pass_href + window.location.search);
      } else {
        $(this).attr('href', pass_href + window.location.search.replace('?', '&'));
      }
    });

    $('.primary-nav [uk-tab] >li:not(.uk-tab-responsive, .uk-disabled)').hover(function () {
      UIkit.tab($(this).parent()).show($(this).index());
    });

    UIkit.util.on(document, 'show', '#component-tab-left', function () {
      let tabNav = $('.uk-dropdown.uk-open > .uk-grid'),
        NewHeight = $('.uk-dropdown.uk-open .uk-switcher > .uk-active').outerHeight();
      $(tabNav).animate({height: NewHeight,}, 120);
    });

// Promo Bar - Set Cookie when 'X' is clicked, and hide promo bar div
    let promoBar = $('#promo-bar.allow-cookie')
    let promoBarPlaceholder = $('#promo-placeholder');
    if (promoBar.length) {
      if (Cookies.get('promoBarCookie') === 'cookieSet') {
        promoBarPlaceholder.hide();
        promoBar.hide();
      } else {
        let navHeight = $('#site-header-2').height();
        let cookieEx = promoBar.data('length')
        promoBar.show();
        promoBar.find('span.close-promo').click(function () {
          Cookies.set('promoBarCookie', 'cookieSet', {expires: cookieEx})
          promoBarPlaceholder.hide();
        })
      }
    }
// Bottom bannar  - Set Cookie when 'X' is clicked, and hide bottom banner
    let bottomBanner = $('.bottom-banner-on-page #bottom-banner')
    if (bottomBanner.length) {
      if (Cookies.get('bottomBannerCookie') === 'cookieSet') {
        bottomBanner.hide();
      } else {
        let cookieEx = bottomBanner.data('length')
        // console.log(cookieEx)
        bottomBanner.show();
        bottomBanner.find('a.close-bottom-banner').click(function () {
          Cookies.set('bottomBannerCookie', 'cookieSet', {expires: cookieEx})
        })
      }
    }

// Dynamically get header height and add offset to any button that begins with '#'
    let headerMain = $('header#site-header').outerHeight(),
      headerPromo = $('#promo-bar').is(':visible') ? $('#promo-bar').outerHeight() : 0;
    let headerHeight = headerMain + headerPromo;
    $('a[href^=#].uk-button:not([uk-scroll]):not(.scroll-to-accrd), li[class*="btn-nav-item"] a[href^=#]:not([uk-scroll]):not(.scroll-to-accrd)').attr('uk-scroll', 'offset:' + headerHeight)


// Test Listing Archive - Update button text when a filter is selected
    let filtersCount = 0
    $('#test-listings-filter ul li a').click(function () {
      filtersCount = filtersCount + 1;
      let selectedFilterValue = $(this).text(),
        mobileCondBadge = $('.active-filter-badges .reset-condition-filter'),
        mobileTypeBadge = $('.active-filter-badges .reset-type-filter')
      mobileCondBadge.data('slug', '')

      if ($(this).parent().parent().attr('id') === 'conditions-filter-list') {
        $('button.conditions-button').text(selectedFilterValue);
        mobileCondBadge.html(selectedFilterValue + '<img src="/wp-content/uploads/2022/02/outline-close.svg" alt=""/>').attr('data-slug', $(this).parent('li').data('slug')).addClass('active')
      } else {
        $('button.types-button').text(selectedFilterValue);
        mobileTypeBadge.html(selectedFilterValue + '<img src="/wp-content/uploads/2022/02/gray-filled-close.svg" alt=""/>').addClass('active')
      }
    })

    UIkit.util.on(document, 'show', '.uk-lightbox', function () {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'modalOpened',
      });
    })

// Test Listing Archive -
// • Add custom 'active' class to items that are visible after the filter event
// • Display Category header of 'active' items
// • If no items match the filter criteria, display 'no results' section
// • Resets search input to '' after filter event
    UIkit.util.on(document, 'afterFilter', '#test-loop', function () {
      // Add custom 'active' class to items that are visible after the filter event
      $('.test-listing-card.active').removeClass('active');
      $('.test-listing-card:not([style*="display: none"])').addClass('active')

      // Resets search input to '' after filter event
      if ($('#test-loop .searchInput').length) {
        $('#test-loop .searchInput').val('').text('')
      }

      // Show 'no results' section and populate text with filter value/s
      if ($('.test-listing-card').find(':visible').length === 0) {
        $('#test-loop .no-results').addClass('show')

        let conditionSelected = '',
          typeSelected = '',
          filterValues = '';
        if ($('button.conditions-button').text() !== 'All') {
          conditionSelected = $('button.conditions-button').text();
        }
        if ($('button.types-button').text() !== 'All') {
          typeSelected = $('button.types-button').text();
        }
        if (conditionSelected !== '') {
          if (typeSelected !== '') {
            filterValues += '"' + conditionSelected + '" <span>and</span> "' + typeSelected + '"'
          } else {
            filterValues += '"' + conditionSelected + '"'
          }
          $('#test-loop .no-results h3 .search-filter-values').html(filterValues)
        } else if (typeSelected !== '' && conditionSelected === '') {
          filterValues += '"' + typeSelected + '"'
          $('#test-loop .no-results h3 .search-filter-values').html(filterValues)
        } else {
          $('#test-loop .no-results h3').text('No results found')
        }
      } else {
        $('#test-loop .no-results').removeClass('show')
      }

      updateFilterCount(filtersCount)
    })


// Test Listing Archive - In 'no results' section, resets all filters
    $('#test-loop .reset-all-filters').click(function (event) {
      event.preventDefault();

      // $('.filter-group-buttons .filter-group ul li.uk-first-column').each(function() {
      //   $(this).trigger('click')
      // })
      $('.filter-group-buttons .filter-group ul li:first-of-type').trigger('click')
      // $('#conditions-filter-list li:first-of-type').trigger('click')
      // $('button.conditions-button').text('All');
      // $('#types-filter-list li:first-of-type').trigger('click')
      // $('button.types-button').text('All');
      // $('.test-filter-footer .apply-done').text('Done')
      // $('#test-loop .active-filter-badges a.reset-condition-filter').attr('data-slug', '')
      $('#test-loop .active-filter-badges a.active').removeClass('active')
      // if ($('#test-loop .searchInput').length) {
      //   $('#test-loop .searchInput').val('').text('')
      // }
      filtersCount = 0
    })

// Test Listing Archive - Mobile Filter Functionality - remove filter
    $('#test-loop .active-filter-badges a').click(function (event) {
      event.preventDefault();
      if ($(this).hasClass('reset-condition-filter')) {
        $(this).attr('data-slug', '')
        $('#conditions-filter-list li:first-of-type').trigger('click')
      } else {
        $('#types-filter-list li:first-of-type').trigger('click')
      }
      $(this).removeClass('active')
      filtersCount = filtersCount - 1
      updateFilterCount(filtersCount)
    })

    function updateFilterCount(filtersCount) {
      let filterResults = $('#test-loop .test-listings-loop').find('.test-listing-card:visible').length
      if (filtersCount === 1) {
        $('.test-filter-footer .apply-done').text('Apply filter (' + filterResults + ')')
      } else if (filtersCount >= 2) {
        $('.test-filter-footer .apply-done').text('Apply filters (' + filterResults + ')')
      } else {
        $('.test-filter-footer .apply-done').text('Done')
      }
    }

// Docs & Forms After filter hook

    UIkit.util.on(document, 'afterFilter', '#test-loop.docs-forms-loop', function () {
      // $('[data-groupIndex!=""]')
      // $('div[data-groupIndex]').each(function() {
      $('h2[data-groupindex]').each(function () {
        let h2Index = $(this).data('groupindex')
        let cardIndex = $('#test-loop.docs-forms-loop').find('div[data-groupindex=' + h2Index + ']')
        if (cardIndex.find(':visible').length === 0) {
          $(this).removeClass('active').hide()
        } else {
          $(this).addClass('active').show()
        }
        // cardIndex.each(function () {
        //   console.log($(this).data('groupindex'))
        // })
      })
    })



    if ($('.wForm[id="22-WRPR"]').length) {
      $('#tfa_130').val('MYRISK');
    }

// handle toggles/modals in the nav

    $('li.uk-toggle-modal a').each(function () {
      $(this).attr('uk-toggle', 'target:[id*=modal]');
      $(this).removeAttr('uk-scroll');
    });

    $('#offcanvas-nav-2 a[href^=#]').click(function () {
      UIkit.offcanvas('#offcanvas-nav-2').hide();
    });

    $('.header-nav a[href^=#], #offcanvas-nav-2 a[href^=#]').each(function () {
      $(this).attr('uk-scroll', 'offset: 70');
    });


    if (window.location.href.indexOf('qq_ref') > -1) {
      let webFormField = $('input[title="Web_Form_URL__c"]'),
        qq_ref = getParameterByName('qq_ref'),
        webFormURL = webFormField.val();

      if (window.location.href.indexOf('qq_add') > -1) {
        let qq_add = getParameterByName('qq_add');
        webFormField.val(webFormURL.replace('/order-kit/', '/results/' + qq_ref + '/').replace('qq_ref=' + qq_ref + '&', '').replace('?', 'access-team/?').replace('&qq_add=' + qq_add, ''));
      } else {
        webFormField.val(webFormURL.replace('/order-kit/', '/results/' + qq_ref + '/').replace('qq_ref=' + qq_ref + '&', ''));
      }
    }


    if (window.location.href.indexOf('tfa_next') > -1 && window.location.href.indexOf('last_success') > -1) {
      $('html:not(.uk-modal-page), body:not([style="overflow-y: scroll;"])').animate({
        scrollTop: $('#wFormThankYouPage').offset().top - $('header.header').outerHeight(),
      }, 800);
    }

    if ($('.qq-wrapper').length) {
      var url = window.location.href,
        quiziframe = $('iframe[data-src*="https://myriad.tfaforms.net/22"]'),
        iframeUrl = quiziframe.length > 0 ? new URL(quiziframe.attr('data-src')) : '',
        survPage = url.indexOf('dear-survivor') >= 0,
        QualBURL = survPage ? url.replace('/dear-survivor/', '/dear-survivor/results/qualifiedb/') : url.replace('/hereditary-cancer-risk/', '/hereditary-cancer-risk/results/qualifiedb/'),
        QualAURL = survPage ? url.replace('/dear-survivor/', '/dear-survivor/results/qualifieda/') : url.replace('/hereditary-cancer-risk/', '/hereditary-cancer-risk/results/qualifieda/'),
        iframeUrlB = 'qualifiedb',
        iframeUrlA = 'qualifieda';
      var webURLfield = $('input[title="Web_Form_URL__c"]');
      var webURL = QualBURL;
      var dataRefURL = iframeUrlB;
      var accessTeam = '';
      var iframeaccessTeam = '';

      if (window.location.search) {
        $('[data-label="use virtual care"], [data-label="order a kit"], #quiz a.uk-button').each(function () {
          var virtualCarehref = $(this).attr('href');

          if (virtualCarehref.indexOf('?') === -1) {
            $(this).attr('href', virtualCarehref + window.location.search);
          } else {
            $(this).attr('href', virtualCarehref + window.location.search.replace('?', '&'));
          }
        });
      }

      // $('button[data-id="not at risk"]').each(function () {
      //   $(this).attr('data-value', 'results reached unqualified');
      // });
      //
      // $('button[data-id*="next step"]').each(function () {
      //   $(this).attr('data-value', 'results reached qualified b');
      // });

      $('button[data-action="personal history"][data-value="Yes"]').on('click', function () {
        webURL = QualAURL;
        dataRefURL = iframeUrlA;

        // $('button[data-id*="next step"]').each(function () {
        //   $(this).attr('data-value', 'results reached qualified a');
        // });
      });

      $('button[data-id*="next step"]').on('click', function () {
        $('#quiz').closest('div').find('h2.title').first().text('Take the next step in getting tested');
      });

      $('button[data-action*="before next"][data-label="get tested"]').on('click', function () {

        let submitButton = $('div#quiz input#submit_button');
        let submitVal = submitButton.attr('data-action');

        submitButton.attr('data-action', submitVal + ' - Access');
        accessTeam = 'access-team/';
        iframeaccessTeam = '/access-team';

        $('a[data-label="order a kit"]').each(function () {
          let btnhref = $(this).attr('href');
          if (btnhref.indexOf('qualifieda') > -1) {
            $(this).attr('href', btnhref + '&qq_add=access-team');
          } else if (btnhref.indexOf('qualifiedb') > -1) {
            $(this).attr('href', btnhref + '&qq_add=access-team');
          }
        });

      });

      $('button[data-id="livechat"]').on('click', function () {
        $('.embeddedServiceHelpButton .uiButton .helpButtonLabel .message').click();
      });
      $('button[data-id="order kit"], button[data-id="order a kit"]').on('click', function () {
        webURLfield.val(webURL.replace('?', accessTeam + '?'));

        //set src to same src with accessTeam, then append web URL data
        if (quiziframe.length > 0) {
          iframeUrl.searchParams.set('qq_ref', dataRefURL + iframeaccessTeam);
          quiziframe.attr('data-src', iframeUrl);
        }
      });


      if (jQuery('#quiz-popup').length > 0) {
        setTimeout(function () {
          $('#quiz-popup.inactive').modal({
            fadeDuration: 250,
          });

        }, 10000);
      }


      function get_height(element) {
        // console.log(element);
        let previousCss = element.attr('style');

        element.css({
          position: 'absolute', // Optional if #myDiv is already absolute
          visibility: 'hidden',
          display: 'block',
        });

        let optionHeight = element.height();

        element.attr('style', previousCss ? previousCss : '');
        // console.log(optionHeight);su
        return optionHeight;
      }

      $('input[data-id]:not([data-id="livechat"]), button[data-id]:not([data-id="livechat"])').on('click', function () {
        let dataID = $(this).data('id'),
          parent = $(this).closest('.qq-wrapper');
        parent.find('.step.active').removeClass('active');


        $('.step[data-id="' + dataID + '"] iframe[data-src]').each(function () {
          let pass_href = $(this).attr('data-src');
          if (pass_href) {
            if (pass_href.indexOf('?') === -1) {
              $(this).attr('src', pass_href + window.location.search);
            } else {
              $(this).attr('src', pass_href + window.location.search.replace('?', '&'));
            }
          }
        });


        parent.find('.step[data-id=\'' + dataID + '\']').addClass('active');
        parent.height(parent.find('.step.active .question').innerHeight());

        if ($('.prequiz-notice').is(':visible')) {
          $('.prequiz-notice').slideUp();
        }

        // Scroll quiz to top of screen on button click
        // $('html:not(.uk-modal-page), body:not([style="overflow-y: scroll;"])').animate({
        //   scrollTop: $('#quiz').offset().top - $('header.header').outerHeight(),
        // }, 800);


      });

      function setHeight() {
        let parent = $('.qq-wrapper');
        parent.height(parent.find('.step.active .question').innerHeight());
      }

      $('.wForm input[type=radio]').on('change', function () {
        setTimeout(() => {
          setHeight();
        }, 100);
      });

      $('.qq-wrapper').each(function () {
        if (window.location.href.indexOf('tfa_') > -1) {
          $('.prequiz-notice').hide();
          $('#quiz').closest('div').find('h2.title').text('MyRisk™ Order Confirmation');
          let first = $(this).find('.step[data-id="order kit"]'),
            firstHeight = get_height(first);
          first.addClass('active');
          first.find('.description > p, .description > .title, .description > .u-text--sm').hide();
          if (!$(this).closest('#quiz-popup').length) {
            $(this).height(firstHeight);
          }
          $(document).scrollTop($('#quiz').offset().top);

        } else {
          let first = $(this).find('.step:first-child'),
            firstHeight = get_height(first);
          first.addClass('active');
          if (!$(this).closest('#quiz-popup').length) {
            $(this).height(firstHeight);
          }
        }
      });

      setTimeout(function () {
        setHeight();
      }, 50);

      // recalculate heights on page resizes with timeout
      var resizeTimer;
      $(window).on('resize', function () {

        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {

          setHeight();

        }, 50);

      });


      UIkit.util.on(document, 'show', '[id*="modal"]', function () {
        setHeight();
      });

      UIkit.util.on(document, 'show', '*', function () {
        setHeight();
      });
    } else {
      // defer iframes until document ready
      $(window).load(function () {
        $('iframe[data-src]').each(function () {
          let pass_href = $(this).attr('data-src');
          if (pass_href) {
            if (pass_href.indexOf('?') === -1) {
              $(this).attr('src', pass_href + window.location.search);
            }
          }
        });
      });
    }

    if ($('[uk-modal]').length) {
      if (window.location.hash && $(window.location.hash + '[uk-modal]').length) {
        UIkit.modal($(window.location.hash + '[uk-modal]')).show();
      } else {
        $('[uk-modal]').each(function () {
          if ($(this).find('.wFormThankYou').length) {
            UIkit.modal($(this)).show();
          }
        });
      }
    }


//  Precise Landing Page
    function isNPI(npi) {
      let regexp = /^\d{10}$/;

      if (regexp.test(npi)) {
        return true;
      } else {
        return false;
      }
    }

    function isZip(zip) {
      let regexp = /^[0-9]{5}(?:-[0-9]{4})?$/;

      if (regexp.test(zip)) {
        return true;
      } else {
        return false;
      }
    }

    function isEmail(email) {
      let regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (regexp.test(email)) {
        return true;
      } else {
        return false;
      }
    }

    if ($('body.page-id-18783').length) {
      $.fn.serializeObject = function () {
        var o = {};
        var a = this.serializeArray();
        $.each(a, function () {
          if (o[this.name] !== undefined) {
            if (!o[this.name].push) {
              o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
          } else {
            o[this.name] = this.value || '';
          }
        });
        return o;
      };

      $(document).ready(function () {

        $('#submit_button').click(function (event) {

          event.preventDefault();
          var error = 0;
          var npiValid = true;
          var specValid = true;
          var fNameValid = true;
          var lNameValid = true;
          var emailValid = true;
          var zipValid = true;
          var phoneValid = true;
          if (document.getElementById('tfa_150').value == '' || !isNPI(document.getElementById('tfa_150').value)) {
            $('#tfa_150').css('border-color', '#ff0000');
            npiValid = false;
            error++;
          } else {
            $('#tfa_150').css('border-color', '#e3e3e3');
            npiValid = true;
          }

          if (document.getElementById('tfa_193').value == '' || document.getElementById('tfa_193').value == 'Please select...') {
            $('#tfa_193').css('border-color', '#ff0000');
            specValid = false;
            error++;
          } else {
            $('#tfa_193').css('border-color', '#e3e3e3');
            specValid = true;
          }
          if (document.getElementById('tfa_187').value == '') {
            $('#tfa_187').css('border-color', '#ff0000');
            fNameValid = false;
            error++;
          } else {
            $('#tfa_187').css('border-color', '#e3e3e3');
            fNameValid = true;
          }

          if (document.getElementById('tfa_188').value == '') {
            $('#tfa_188').css('border-color', '#ff0000');
            lNameValid = false;
            error++;
          } else {
            $('#tfa_188').css('border-color', '#e3e3e3');
            fNameValid = true;
          }
          if (document.getElementById('tfa_216').value == '') {
            $('#tfa_216').css('border-color', '#ff0000');
            phoneValid = false;
            error++;
          } else {
            $('#tfa_216').css('border-color', '#e3e3e3');
            phoneValid = true;
          }
          if (document.getElementById('tfa_47').value == '' || !isEmail(document.getElementById('tfa_47').value)) {
            $('#tfa_47').css('border-color', '#ff0000');
            emailValid = false;
            error++;
          } else {
            $('#tfa_47').css('border-color', '#e3e3e3');
            emailValid = true;
          }

          if (document.getElementById('tfa_114').value == '' || !isZip(document.getElementById('tfa_114').value)) {
            $('#tfa_114').css('border-color', '#ff0000');
            zipValid = false;
            error++;
          } else {
            $('#tfa_114').css('border-color', '#e3e3e3');
            zipValid = true;
          }
          if (!npiValid || !fNameValid || !lNameValid || !emailValid || !phoneValid || !zipValid || !specValid) {
            //      $('html, body').animate({
            //     scrollTop: $("h1").offset().top
            // }, 500);
            alert('You have ' + error + ' error(s) in your form. Please fill all required fields.');
          } else {
            $.ajax({
              type: 'POST',
              url: 'https://services.myriad.com/marketing/AELookupPrecise/',
              // data: {'formJSON': JSON.stringify($('#4872888').serializeObject())},
              data: {
                'formJSON': JSON.stringify({
                  'tfa_193': $('#tfa_193').val(),
                  'tfa_114': $('#tfa_114').val(),
                  'tfa_dbFormId': $('#tfa_dbFormId').val()
                })
              },
              success: function (data) {


                $('#tfa_151').val(data[1]);
                $('#tfa_154').val(data[2]);
                $('#tfa_152').val(data[3]);
                $('#4872888').submit();
              },
            });
          }

        });


        const urlParams = new URLSearchParams(location.search);
        if (urlParams.has('tfa_next')) {
          $('html, body').animate({
            scrollTop: $('#enroll').offset().top,
          }, 500);
          $('#enroll h2').css('display', 'none');
          $('#enroll h2 + p').css('display', 'none');
          $('.formInstructions').css('display', 'none');
        }

      });
    }

//  Precise Registry LP
    if ($('body.page-id-19088').length) {
      $(document).ready(function () {
        const urlParams = new URLSearchParams(location.search);
        if (urlParams.has('tfa_next')) {
          $('html, body').animate({
            scrollTop: $('#enroll').offset().top,
          }, 500);
          $('#enroll h2').css('display', 'none');
          $('#enroll h2 + p').css('display', 'none');
          $('.formInstructions').css('display', 'none');
        }
        $('#tfa_148-L span:nth-child(3)').html('I have read and accepted the <a href="#">End User License Agreement</a>');
      });
    }

//  Precise Treatment Registry LP
    if ($('body.page-id-19091').length) {
      $(document).ready(function () {
        const urlParams = new URLSearchParams(location.search);
        if (urlParams.has('tfa_next')) {
          $('html, body').animate({
            scrollTop: $('#enroll').offset().top,
          }, 500);
          $('#enroll h2').css('display', 'none');
          $('#enroll h2 + p').css('display', 'none');
          $('.formInstructions').css('display', 'none');
        }
      })
    }

//  GTM
    function getParameterByName(name, url = window.location.href) {
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) {
        return null;
      }
      if (!results[2]) {
        return '';
      }
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

// Global Nav (2) - Animation
    $(document).ready(function () {

      let border = $('#site-header-2 .primary-nav-2 ul.main-nav div.nav-active-border'),
        navItem = $('#site-header-2 .primary-nav-2 ul.main-nav > li')

      navItem.on('mouseenter', function () {
        activeBorder($(this).find('> a'))
      })

      navItem.on('mouseleave', function () {
        border.css('opacity', '0')
      })


      function activeBorder(item) {
        let leftPos = item.parent().position().left,
          topPos = item.parent().position().top,
          widthPos = item.parent().width(),
          heightPos = item.innerHeight()

        border.css({
          'left': leftPos,
          'width': widthPos,
          'top': topPos + heightPos - 2,
          'height': '8px',
          'opacity': '1',
        })
      }

      $(window).on('resize', function () {
        if ($('#site-header-2 .primary-nav-2 ul.main-nav > li > a[aria-expanded=true]').length > 0) {
          activeBorder($('#site-header-2 .primary-nav-2 ul.main-nav > li > a[aria-expanded=true]'))
        }
      })
      // activeBorder($('#site-header-2 .primary-nav-2 ul.main-nav > li.current-menu-ancestor > a'))

    })



  },
  finalize() {


    $(document).ready(function () {

      //  if #string on load, scroll to section
      if ($(window.location.hash).length > 0) {
        let navHeight = $('.header-nav').outerHeight(),
          promoHeight = $('#promo-bar').is(':visible') ? $('#promo-bar').outerHeight() : 0,
          adminBarHeight = $('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0,
          totalHeight = navHeight + promoHeight + adminBarHeight;
        $('html,body').animate({
          scrollTop: $(window.location.hash).offset().top - totalHeight,
        }, 900, 'swing');
      }


      // when wForms is loaded call this
      var wformsReadyCallbackLoad = function () {
        wFORMS.behaviors.paging.warnOnUnload = false;
      }

      // add event listener to fire when wForms is fully loaded
      document.addEventListener('wFORMSLoaded', wformsReadyCallbackLoad);


    });
// JavaScript to be fired on all pages, after page specific JS is fired
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js